"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import Cookies from "js-cookie"; // Assuming you're using js-cookie
import { z } from "zod";

export default function TrackingParamsHandler() {
  const searchParams = useSearchParams();

  const savePromoTag = (promoTag: string) => {
    const schema = z.string().min(1).max(32).trim();

    const result = schema.safeParse(promoTag);

    if (result.success) {
      Cookies.set("promoTag", promoTag, {
        domain: "." + process.env.NEXT_PUBLIC_BASE_DOMAIN,
        secure: process.env.NODE_ENV !== "development",
      });
    }
  };

  const saveGclid = (gclid: string) => {
    Cookies.set("gclid", gclid, {
      domain: "." + process.env.NEXT_PUBLIC_BASE_DOMAIN,
      secure: process.env.NODE_ENV !== "development",
    });
  };

  const saveCampaign = (campaignCode: string) => {
    Cookies.set("campaign", campaignCode, {
      domain: "." + process.env.NEXT_PUBLIC_BASE_DOMAIN,
      secure: process.env.NODE_ENV !== "development",
    });
  };

  useEffect(() => {
    const campaignCode = searchParams.get("c");
    if (campaignCode) {
      saveCampaign(campaignCode);
    }

    const gclid = searchParams.get("gclid");
    if (gclid) {
      saveGclid(gclid);
    }

    const promoTag = searchParams.get("promoTag");
    if (promoTag) {
      savePromoTag(promoTag);
    }
  }, [searchParams]);

  return null;
}
